import React from 'react';
import PropTypes from 'prop-types';
import { ReportParamFilter } from '@smorder/core';
import FilterWrapper from '../filter-wrapper/filter-wrapper';

const defaultFilters = ['VonDatum', 'BisDatum'];

const ParamFilter = ({ param, setParamValue, style }) => {
  const {
    name,
  } = param;

  if (defaultFilters.includes(name)) {
    return null;
  }

  const content = <ReportParamFilter param={param} setParamValue={setParamValue} />;


  return (
    <FilterWrapper title={name} height={1} style={style}>
      {content}
    </FilterWrapper>
  );
};

ParamFilter.propTypes = {
  param: PropTypes.object.isRequired,
  style: PropTypes.object,
  setParamValue: PropTypes.func.isRequired,
};

ParamFilter.defaultProps = {
  style: null,
};

export default ParamFilter;
